// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"19ef9e91","367":"e45af498","937":"3d30584f"}[chunkId] + ".chunk.js";
};